import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

import { greyDarkWithOpacity } from "@/angelouCE/utils/constants";
const { breakpoints } = constants;
const {
  textSObj: { fontSize: textSFontSize },
} = typographyStyles;
const { mediaQuery } = mediaQueryStyles;
const { xs, md } = breakpoints.BreakpointNames;

const uiColors = constants.colors.ui;

export const annotationCardCss = (isExpanded) => ({
  boxShadow: isExpanded ? `0px 2px 6px ${greyDarkWithOpacity}` : null,
  border: `1px solid ${uiColors.neutral[100]}`,
  padding: "16px",
  borderRadius: "3px",
  marginBottom: "24px",

  "&:focus": {
    outline: "-webkit-focus-ring-color auto 5px",
  },

  [mediaQuery.between(xs, md)]: {
    marginBottom: "32px",
  },
});

// To be used for styling highlighted text
export const nodeCSS = {
  paragraph: {
    fontSize: textSFontSize,
    [mediaQuery.downTo(xs)]: {
      fontSize: textSFontSize,
      margin: "15px 0 0",
    },
  },
};
